import { useState } from 'react'
import useFetch from '../../../../../Utilities/API/useFetch.react'
import { TBButton } from '../../../../Commons/Buttons/TBButton.react'
import { Icon, ProgressBar } from 'react-materialize'
import { StyledUpload } from './UploadCSV.styles'
import WrappedAlert from '../../../../Commons/Alerts/WrappedAlert'

const UploadCSV = () => {
  const [csv, setCSV] = useState(null)
  const [status, setStatus] = useState('idle')
  const [error, setError] = useState(null)

  const [fetchUrl] = useFetch()

  const isLoading = status === 'loading'
  const isSuccess = status === 'success'
  const isError = status === 'error'

  const handleChange = (event) => {
    const CSV = event.target.value
    setCSV(CSV)
  }

  const handleSubmit = () => {
    if (csv) {
      setStatus('loading')
      fetchUrl('uploadTransactions', csv).then((response) => {
        if (response.status === 'FAILED') {
          setError({ message: 'Failed to upload CSV', error: 'error' })
          setStatus('error')
        } else {
          setStatus('success')
          setCSV(null)
          setTimeout(() => setStatus('idle'), 3000)
        }
      })
    } else {
      setError({
        message: 'Must upload a valid file before submission',
        error: 'Payload is empty',
      })
      setStatus('error')
    }
  }

  return (
    <StyledUpload>
      <div className={'je-header'}>
        <h4>Upload CSV</h4>
        <Icon>file_copy</Icon>
      </div>
      <div className={'content'}>
        <input
          onChange={handleChange}
          value={csv}
          id={'fileSelect'}
          type={'file'}
          accept={
            '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
          }
        />
        {isLoading && <ProgressBar />}
      </div>
      {(isSuccess || isError) && (
        <WrappedAlert
          type={isSuccess ? 'success' : 'error'}
          message={
            isError ? error.message : 'Succesfully uploaded transactions'
          }
        />
      )}
      <div className={'submit'}>
        <TBButton disabled={isLoading} onClick={handleSubmit}>
          {isLoading ? 'Submitting' : 'Upload Transactions'}
        </TBButton>
      </div>
    </StyledUpload>
  )
}

export default UploadCSV
